import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propBool, propShape, propStr, } from '../../../../helpers/custom-prop-types';
import BlurText from '../../../Ui/Common/BlurText';
const AboutProfileOrganizationName = (props) => {
    const { isBlur, organizationName, unit } = props;
    if (isBlur) {
        return (_jsx(BlurText, Object.assign({ component: 'p', isBlur: true }, { children: organizationName })));
    }
    return (_jsx("p", { children: !unit ? (organizationName) : (_jsxs("a", Object.assign({ className: 'is-unit', href: `/consultant_unit/${unit.urlCode}`, rel: 'noreferrer noopener', target: '_blank' }, { children: [organizationName, _jsx("i", Object.assign({ className: 'material-icons' }, { children: "launch" }))] }))) }));
};
AboutProfileOrganizationName.propTypes = {
    isBlur: propBool().isRequired,
    organizationName: propStr().isRequired,
    unit: propShape(),
};
AboutProfileOrganizationName.defaultProps = {
    unit: null,
};
export default AboutProfileOrganizationName;
